import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from "d3";
import _ from "lodash";

import UsaStateHovers from "../Map/UsaStateHovers";
import UsaStateBorders from "../Map/UsaStateBorders";
import NationalSelectorShapes from "./NationalSelectorShapes";
import UsaOutline from "../Map/UsaOutline";
import HoverOver from "../HoverOver";

import '../Map/Map.css';
import './NationalSelector.css';

class NationalSelector extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 250
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    const maxHeight = this.props.maxHeight || width;
    this.setState({width: width, height: Math.min(maxHeight, width * .61)});
  }

  render() {
    return (
      <div ref="wrapper" className="NationalSelector" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <UsaOutline width={this.state.width} height={this.state.height}/>
          <NationalSelectorShapes
            width={this.state.width}
            height={this.state.height}
            selected={this.props.selectedState}
          />
          <UsaStateHovers
            width={this.state.width}
            height={this.state.height}
            onHoverOver={(stateFips, coords) => {
              const hover = {
                data: _.get(this, ['props', 'dict', stateFips], null),
                props:this.props,
                coords,
              };

              this.setState({hover});
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_over");
            }}
            onHoverOut={stateFips => {
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_out");
              this.setState({hover: null})
            }}
            onClick={stateFips => {
              if (this.props.onClick) {
                this.props.onClick(stateFips)
              }
            }}/>
          <UsaStateBorders width={this.state.width} height={this.state.height}/>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

NationalSelector.propTypes = {
  dict: PropTypes.object,
  onClick: PropTypes.func,
  maxHeight: PropTypes.number,
  selectedState: PropTypes.number
};

export default NationalSelector;


// WEBPACK FOOTER //
// ./src/charts/NationalSelector/index.js